var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

var BRDPartnerTermsNotice = function BRDPartnerTermsNotice(props) {
  var goBack = props.goBack;
  return __jsx(Container, null, __jsx(Row, null, __jsx(Col, {
    className: "p-3"
  }, __jsx("p", null, "In vederea indeplinirii obiectului contractului dintre Conso Media Grup SRL (Conso) si BRD, aceasta din urma are obligatia de a transmite catre Conso anumite informatii despre identitatea dvs, valoarea. si statusul creditului pentru care v-ati exprimat interesul prin prezentul formular."), __jsx("p", null, "Temeiul prelucrarii: consimt\u0103mantul dvs (Art. 6 alin. 1 lit. (a) GDPR)."), __jsx("p", null, "In cazul in care nu sunteti de acord cu transmiterea acestor informatii, BRD nu va putea da curs cererii dvs. legate de acordarea creditului."), __jsx("p", null, "Va puteti retrage consimtamantul in orice moment ulterior acordarii, insa nu mai tarziu de momentul contactarii dvs. de catre BRD."), __jsx("p", null, "Bifand aceasta optiune, sunteti de acord ca numele, prenumele dvs., status solicitarii si valoarea creditului sa ne fie comunicate de catre BRD in scopul mentionat mai sus."), __jsx(Button, {
    variant: "outline-secondary",
    onClick: goBack
  }, __jsx(FontAwesomeIcon, {
    icon: faChevronLeft,
    height: "16",
    width: "16",
    className: "mr-2"
  }), "\xCEnapoi"))));
};

export default BRDPartnerTermsNotice;